import axios from "axios";
import { urls } from "../utils/AppManager";
import { getAuthHeaders } from "../utils/headers";
import { getAuthRefreshHeaders } from "../utils/headers";

// custom axios instance for cookies

// const api = axios.create({
// 	withCredentials: true
// });

export const getLogin = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.login;

  try {
    const response = await axios.post(url, payload);
    return response.data; // Always return the full response data
  } catch (error) {
    console.error("Axios error:", error);
    throw error;
  }
};


// service to generate OTP

export const genOTP = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.genOTP;
  // console.log(url);
  const res = await axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error")
    });
  return res;
}

export const verifyOTP = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.verifyOTP;
  const res = await axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error")
    });
  return res;
}

export const getRefresh = async () => {
  console.log("refresh api called");
  const url = process.env.REACT_APP_API_BASE_URL + urls.refresh;
  const headers = getAuthRefreshHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getLogout = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.logout;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};
